// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"45590304","226":"95ea8e57","565":"8b870d1a","795":"20935a76","845":"b8cd8404","853":"e741944c","860":"5a17d34a","887":"4a766578","925":"f89c3c22"}[chunkId] + ".chunk.js";
};